/* ============================================================
   2D Shirt Store — theme JS
   ============================================================ */
(function () {
  'use strict';

  // ---------- Mobile menu toggle ----------
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const nav = document.querySelector('.header__nav');
  const closeMenu = () => {
    nav?.classList.remove('is-open');
    document.body.classList.remove('nav-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
  };
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      document.body.classList.toggle('nav-open', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Close on link click (so navigation feels right)
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      if (window.matchMedia('(max-width: 833px)').matches) closeMenu();
    }));

    // Tap-toggle submenu on mobile (parent link still navigates on second tap)
    nav.querySelectorAll('.has-submenu > .header__menu-link').forEach(link => {
      link.addEventListener('click', e => {
        if (!window.matchMedia('(max-width: 833px)').matches) return;
        const parent = link.closest('.has-submenu');
        if (!parent.classList.contains('is-open')) {
          e.preventDefault();
          // Close any other open submenus
          nav.querySelectorAll('.has-submenu.is-open').forEach(s => { if (s !== parent) s.classList.remove('is-open'); });
          parent.classList.add('is-open');
        }
      });
    });

    // Close on Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeMenu();
    });

    // Close on resize past breakpoint
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!window.matchMedia('(max-width: 833px)').matches) closeMenu();
      }, 100);
    });
  }

  // ---------- All Teams modal ----------
  const teamsModal = document.getElementById('AllTeamsModal');
  if (teamsModal) {
    const openBtn = document.querySelector('[data-all-teams-open]');
    const closeEls = teamsModal.querySelectorAll('[data-all-teams-close]');
    const search = teamsModal.querySelector('[data-all-teams-search]');
    const items = teamsModal.querySelectorAll('.all-teams-item');
    const emptyMsg = teamsModal.querySelector('[data-all-teams-empty]');
    let lastFocus = null;

    const openModal = () => {
      lastFocus = document.activeElement;
      teamsModal.hidden = false;
      document.body.classList.add('nav-open');
      requestAnimationFrame(() => search?.focus());
    };
    const closeModal = () => {
      teamsModal.hidden = true;
      document.body.classList.remove('nav-open');
      if (search) { search.value = ''; filterTeams(''); }
      lastFocus?.focus();
    };
    const filterTeams = q => {
      const term = q.trim().toLowerCase();
      let visible = 0;
      items.forEach(it => {
        const name = it.dataset.teamName || '';
        const match = !term || name.includes(term);
        it.classList.toggle('is-hidden', !match);
        if (match) visible++;
      });
      if (emptyMsg) emptyMsg.hidden = visible > 0;
    };

    openBtn?.addEventListener('click', openModal);
    closeEls.forEach(el => el.addEventListener('click', closeModal));
    search?.addEventListener('input', e => filterTeams(e.target.value));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !teamsModal.hidden) closeModal();
    });
    // Close modal when clicking a team link (so navigation feels natural)
    items.forEach(it => it.addEventListener('click', () => setTimeout(closeModal, 50)));
  }

  // ---------- Price range slider (dual-handle) ----------
  document.querySelectorAll('[data-price-slider]').forEach(slider => {
    const minThumb  = slider.querySelector('[data-price-thumb-min]');
    const maxThumb  = slider.querySelector('[data-price-thumb-max]');
    const minLabel  = slider.querySelector('[data-price-label-min]');
    const maxLabel  = slider.querySelector('[data-price-label-max]');
    const active    = slider.querySelector('[data-price-track-active]');
    const minHidden = slider.querySelector('[data-price-input-min]');
    const maxHidden = slider.querySelector('[data-price-input-max]');
    if (!minThumb || !maxThumb) return;

    const absMin = Number(slider.dataset.absMin) || 0;
    const absMax = Number(slider.dataset.absMax) || 100;
    const range  = absMax - absMin;
    const minGap = 5; // minimum gap between handles (in dollars, matches step)

    const fmt = (v) => '$' + v;

    const paint = () => {
      const minV = Number(minThumb.value);
      const maxV = Number(maxThumb.value);
      const lPct = ((minV - absMin) / range) * 100;
      const rPct = ((maxV - absMin) / range) * 100;
      active.style.left  = lPct + '%';
      active.style.width = (rPct - lPct) + '%';
      if (minLabel) minLabel.textContent = fmt(minV);
      if (maxLabel) maxLabel.textContent = fmt(maxV);
      if (minHidden) minHidden.value = minV;
      if (maxHidden) maxHidden.value = maxV;
    };

    minThumb.addEventListener('input', () => {
      // Push max away if min crosses it
      if (Number(minThumb.value) > Number(maxThumb.value) - minGap) {
        minThumb.value = Number(maxThumb.value) - minGap;
      }
      paint();
    });
    maxThumb.addEventListener('input', () => {
      if (Number(maxThumb.value) < Number(minThumb.value) + minGap) {
        maxThumb.value = Number(minThumb.value) + minGap;
      }
      paint();
    });

    paint();
  });

  // ---------- Collection filter drawer (mobile) ----------
  (function initFilterDrawer() {
    const toggle = document.querySelector('[data-filter-toggle]');
    const closer = document.querySelector('[data-filter-close]');
    if (!toggle) return;

    const open = () => {
      document.body.classList.add('filters-open');
      toggle.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      document.body.classList.remove('filters-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', open);
    closer?.addEventListener('click', close);

    // Click on backdrop (the ::before pseudo) — detect via body click outside panel
    document.addEventListener('click', e => {
      if (!document.body.classList.contains('filters-open')) return;
      const panel = document.querySelector('[data-filter-panel]');
      if (!panel) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      close();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && document.body.classList.contains('filters-open')) close();
    });
  })();

  // ---------- Header search drawer (predictive results) ----------
  (function initSearchDrawer() {
    const toggle  = document.querySelector('[data-search-toggle]');
    const drawer  = document.querySelector('[data-search-drawer]');
    const input   = document.querySelector('[data-search-input]');
    const closeBtn = document.querySelector('[data-search-close]');
    const results = document.querySelector('[data-search-results]');
    if (!toggle || !drawer || !input) return;

    const formatMoney = (cents) => '$' + (cents / 100).toFixed(2);

    const openDrawer = () => {
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => input.focus());
    };
    const closeDrawer = () => {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      input.value = '';
      if (results) { results.innerHTML = ''; results.hidden = true; }
    };
    toggle.addEventListener('click', () => {
      drawer.hidden ? openDrawer() : closeDrawer();
    });
    closeBtn?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
    // Click outside the drawer (but not the toggle) closes it
    document.addEventListener('click', e => {
      if (drawer.hidden) return;
      if (drawer.contains(e.target)) return;
      if (toggle.contains(e.target)) return;
      closeDrawer();
    });

    // Predictive search — debounced fetch against /search/suggest.json
    let timer;
    const minLen = 2;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const term = input.value.trim();
      if (term.length < minLen) {
        if (results) { results.innerHTML = ''; results.hidden = true; }
        return;
      }
      timer = setTimeout(() => fetchSuggestions(term), 220);
    });

    async function fetchSuggestions(term) {
      if (!results) return;
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(term)
          + '&resources[type]=product'
          + '&resources[limit]=8'
          + '&resources[options][unavailable_products]=last';
        const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('Search fetch failed');
        const data = await res.json();
        renderResults(term, data.resources?.results?.products || []);
      } catch (err) {
        console.error('[search]', err);
        results.innerHTML = '<p class="header-search__empty">Search unavailable, try again.</p>';
        results.hidden = false;
      }
    }

    function renderResults(term, products) {
      if (!products.length) {
        results.innerHTML = '<p class="header-search__empty">No products match "' + escapeHtml(term) + '". Try different keywords.</p>';
        results.hidden = false;
        return;
      }
      const items = products.map(p => {
        const img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<img alt="" loading="lazy">';
        // /search/suggest.json returns price already formatted ("$29.99"); pass through as-is
        const price = p.price || '';
        return '<a class="header-search__result" href="' + p.url + '">'
          + img
          + '<div class="header-search__result-body">'
          + '<p class="header-search__result-title">' + escapeHtml(p.title) + '</p>'
          + (price ? '<p class="header-search__result-price">' + escapeHtml(price) + '</p>' : '')
          + '</div>'
          + '</a>';
      }).join('');
      const moreUrl = '/search?q=' + encodeURIComponent(term);
      results.innerHTML =
        '<div class="header-search__group">' +
          '<h4 class="header-search__group-title">Products</h4>' +
          items +
        '</div>' +
        '<a class="header-search__more" href="' + moreUrl + '">See all results →</a>';
      results.hidden = false;
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
  })();

  // ---------- Carousel (testimonials, etc.) ----------
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);

  function initCarousel(carousel) {
    const track = carousel.querySelector('[data-carousel-track]');
    const prev  = carousel.querySelector('[data-carousel-prev]');
    const next  = carousel.querySelector('[data-carousel-next]');
    const dotsContainer = carousel.parentElement.querySelector('[data-carousel-dots]');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('[data-carousel-slide]'));
    if (!slides.length) return;

    const slideWidth = () => slides[0].getBoundingClientRect().width;
    const gap = () => parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 20;
    const step = () => slideWidth() + gap();

    const updateNav = () => {
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth - 4;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max;
    };

    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    // Build dots — one per slide, only if more than 1 slide
    let dots = [];
    if (dotsContainer && slides.length > 1) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonials__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', () => {
          slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsContainer.appendChild(dot);
      });
      dots = Array.from(dotsContainer.querySelectorAll('.testimonials__dot'));
    }

    const syncActive = () => {
      const sl = track.scrollLeft;
      let idx = 0;
      slides.forEach((s, i) => {
        if (s.offsetLeft - track.offsetLeft <= sl + slideWidth() / 2) idx = i;
      });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      updateNav();
    };

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { syncActive(); ticking = false; });
    });
    window.addEventListener('resize', syncActive);
    updateNav();
  }

  // ---------- Product gallery (thumb-click swaps main) ----------
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const main   = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelector('[data-gallery-thumbs]');
    if (!main || !thumbs) return;

    thumbs.addEventListener('click', e => {
      const btn = e.target.closest('[data-media-id]');
      if (!btn) return;
      const id = btn.dataset.mediaId;
      thumbs.querySelectorAll('[data-media-id]').forEach(t =>
        t.classList.toggle('is-active', t.dataset.mediaId === id));
      main.querySelectorAll('[data-media-id]').forEach(s =>
        s.classList.toggle('is-active', s.dataset.mediaId === id));
    });
  });

  // ---------- Quantity input ----------
  document.querySelectorAll('.quantity-input').forEach(wrap => {
    const input = wrap.querySelector('input');
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    plus?.addEventListener('click', () => { input.value = Number(input.value) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  // ---------- Smart variant picker ----------
  // Wires every .product-form on the page against its sibling [data-product-meta]
  // JSON (emitted outside the form). Resolves the Style/Size/Color/Brand/Model
  // combo, updates price / SKU / CTA / URL, and greys out unavailable values.
  document.querySelectorAll('.product-form').forEach(initVariantPicker);

  function initVariantPicker(form) {
    // Find the meta script — first look inside the same product section,
    // fall back to the document for resilience against markup tweaks.
    const section = form.closest('.product-detail') || document;
    const metaEl  = section.querySelector('[data-product-meta]') || document.querySelector('[data-product-meta]');
    if (!metaEl) return;

    let meta;
    try { meta = JSON.parse(metaEl.textContent); } catch (e) {
      console.error('[variant picker] invalid meta JSON', e);
      return;
    }
    const variants = meta.variants || [];
    if (!variants.length) return;

    const moneyFormat = metaEl.dataset.moneyFormat || '${{amount}}';
    const variantIdInput = form.querySelector('[data-variant-id]');
    const submitBtn      = form.querySelector('[data-product-submit]');
    const submitText     = form.querySelector('[data-product-submit-text]');
    const submitPrice    = form.querySelector('[data-product-submit-price]');
    const priceWrap      = section.querySelector('[data-product-price]');
    const skuEl          = section.querySelector('[data-product-sku]');
    const availEl        = section.querySelector('[data-product-availability]');
    const optionGroups   = form.querySelectorAll('[data-option-position]');

    const formatMoney = (cents) => {
      if (cents == null) return '';
      const dollars = (cents / 100).toFixed(2);
      const whole = Math.round(cents / 100).toString();
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, dollars)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dollars.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole);
    };

    const getSelected = () => {
      const sel = [];
      optionGroups.forEach(group => {
        const checked = group.querySelector('input[type="radio"]:checked');
        const select  = group.querySelector('select');
        if (checked) sel.push(checked.value);
        else if (select) sel.push(select.value);
        else sel.push(null);
      });
      return sel;
    };

    const matchVariant = (combo) => variants.find(v =>
      (v.option1 == null || combo[0] == null || v.option1 === combo[0]) &&
      (v.option2 == null || combo[1] == null || v.option2 === combo[1]) &&
      (v.option3 == null || combo[2] == null || v.option3 === combo[2])
    );

    const findExactVariant = (selected) => variants.find(v =>
      (v.option1 == null ? !selected[0] : v.option1 === selected[0]) &&
      (v.option2 == null ? !selected[1] : v.option2 === selected[1]) &&
      (v.option3 == null ? !selected[2] : v.option3 === selected[2])
    );

    const markUnavailable = (selected) => {
      optionGroups.forEach(group => {
        const pos = Number(group.dataset.optionPosition) - 1;
        group.querySelectorAll('input[type="radio"]').forEach(input => {
          const test = [...selected];
          test[pos] = input.value;
          const match = matchVariant(test);
          const ok = match && match.available;
          input.closest('.pd-pill')?.classList.toggle('is-unavailable', !ok);
        });
        group.querySelectorAll('select option').forEach(opt => {
          if (!opt.value) return;
          const test = [...selected];
          test[pos] = opt.value;
          const match = matchVariant(test);
          const ok = match && match.available;
          opt.disabled = !ok;
          const baseLabel = opt.dataset.label || opt.value;
          opt.textContent = ok ? baseLabel : `${baseLabel} — Unavailable`;
        });
      });
    };

    const update = () => {
      const selected = getSelected();
      const variant = findExactVariant(selected);

      if (variantIdInput) variantIdInput.value = variant ? variant.id : '';

      optionGroups.forEach((group, i) => {
        const echo = group.querySelector('[data-selected-value]');
        if (echo) echo.textContent = selected[i] || '';
        group.querySelectorAll('.pd-pill').forEach(label => {
          const input = label.querySelector('input[type="radio"]');
          label.classList.toggle('is-selected', !!(input && input.checked));
        });
      });

      if (priceWrap && variant) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (sale) {
          const saved = variant.compare_at_price - variant.price;
          priceWrap.innerHTML =
            '<span class="pd-price__now">' + formatMoney(variant.price) + '</span>' +
            '<s class="pd-price__was">' + formatMoney(variant.compare_at_price) + '</s>' +
            '<span class="pd-price__save">Save ' + formatMoney(saved) + '</span>';
        } else {
          priceWrap.innerHTML = '<span class="pd-price__now">' + formatMoney(variant.price) + '</span>';
        }
      }

      if (submitBtn && submitText) {
        if (!variant) {
          submitBtn.disabled = true;
          submitText.textContent = 'Unavailable';
          if (submitPrice) submitPrice.textContent = '';
        } else if (!variant.available) {
          submitBtn.disabled = true;
          submitText.textContent = 'Sold out';
          if (submitPrice) submitPrice.textContent = '';
        } else {
          submitBtn.disabled = false;
          submitText.textContent = 'Add to cart';
          if (submitPrice) submitPrice.textContent = formatMoney(variant.price);
        }
      }

      if (skuEl) skuEl.textContent = variant && variant.sku ? variant.sku : '';
      if (availEl) {
        if (!variant) availEl.textContent = 'Unavailable';
        else if (variant.available) availEl.textContent = 'In stock';
        else availEl.textContent = 'Sold out';
      }

      // Per-variant featured image — swap main image + active thumb
      if (variant && variant.featured_media_id) {
        const targetId = String(variant.featured_media_id);
        const gallery  = section.querySelector('[data-gallery]');
        if (gallery) {
          gallery.querySelectorAll('.pd-gallery__slide').forEach(s =>
            s.classList.toggle('is-active', s.dataset.mediaId === targetId));
          gallery.querySelectorAll('.pd-gallery__thumb').forEach(t =>
            t.classList.toggle('is-active', t.dataset.mediaId === targetId));
        }
      }

      if (variant && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      markUnavailable(selected);
    };

    form.addEventListener('change', e => {
      if (e.target.matches('input[type="radio"], select')) update();
    });

    // Long-list filter — typing narrows the visible pills (Model: ~80 values)
    form.querySelectorAll('[data-picker-filter]').forEach(input => {
      input.addEventListener('input', e => {
        const term = e.target.value.trim().toLowerCase();
        const pills = input.closest('.pd-picker').querySelectorAll('.pd-pill');
        pills.forEach(p => {
          const v = (p.dataset.value || '').toLowerCase();
          p.style.display = !term || v.includes(term) ? '' : 'none';
        });
      });
    });

    // Hardened click handler — covers browsers where label→input forwarding
    // doesn't fire change (some iOS Safari versions) OR future CSS changes
    // that break the implicit label association. We don't bail when
    // input.checked is already true, because the browser may have set it
    // while skipping the change event — so we run update() unconditionally.
    form.addEventListener('click', e => {
      const pill = e.target.closest('.pd-pill');
      if (!pill || !form.contains(pill)) return;
      const input = pill.querySelector('input[type="radio"]');
      if (!input) return;
      const group = pill.parentElement;
      group.querySelectorAll('input[type="radio"][name="' + input.name + '"]').forEach(i => i.checked = false);
      input.checked = true;
      group.querySelectorAll('.pd-pill').forEach(p => p.classList.remove('is-selected'));
      pill.classList.add('is-selected');
      update();
    });

    // Initial paint — flag combos already sold-out on load
    markUnavailable(getSelected());
  }

  // ---------- Cart drawer ----------
  const CartDrawer = (function () {
    const drawer    = document.querySelector('[data-cart-drawer]');
    if (!drawer) return null;

    const itemsEl   = drawer.querySelector('[data-cart-items]');
    const emptyEl   = drawer.querySelector('[data-cart-empty]');
    const footerEl  = drawer.querySelector('[data-cart-footer]');
    const countEl   = drawer.querySelector('[data-cart-drawer-count]');
    const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    const checkoutAmt = drawer.querySelector('[data-cart-checkout-amount]');
    const closers   = drawer.querySelectorAll('[data-cart-drawer-close]');

    const formatMoney = (cents) => '$' + (cents / 100).toFixed(2);
    const escapeHtml = (str) => String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');

    let cartData = null;
    let fetchPromise = null;

    const open = async () => {
      drawer.hidden = false;
      document.body.classList.add('cart-open');
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      drawer.setAttribute('aria-hidden', 'false');
      // Fetch fresh cart if we haven't yet, OR if it's stale
      await refresh();
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
      // Wait for transition before hiding (so animation can play)
      setTimeout(() => { drawer.hidden = true; }, 300);
    };

    const refresh = async () => {
      if (fetchPromise) return fetchPromise;
      fetchPromise = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(data => { cartData = data; render(); updateHeaderCount(); fetchPromise = null; })
        .catch(err => { console.error('[cart]', err); fetchPromise = null; });
      return fetchPromise;
    };

    let lastCount = -1;
    const updateHeaderCount = () => {
      if (!cartData) return;
      const n = cartData.item_count;
      const changed = lastCount !== -1 && lastCount !== n;
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = n > 0 ? n : '';
        if (changed && n > 0) {
          el.classList.remove('is-updated');
          // Force reflow so the animation restarts when re-added
          void el.offsetWidth;
          el.classList.add('is-updated');
          setTimeout(() => el.classList.remove('is-updated'), 500);
        }
      });
      if (countEl) countEl.textContent = n;
      lastCount = n;
    };

    const render = () => {
      if (!cartData) return;
      const items = cartData.items || [];
      if (items.length === 0) {
        itemsEl.innerHTML = '';
        emptyEl.hidden = false;
        footerEl.hidden = true;
        return;
      }
      emptyEl.hidden = true;
      footerEl.hidden = false;

      itemsEl.innerHTML = items.map(renderItem).join('');
      subtotalEl.textContent = formatMoney(cartData.items_subtotal_price ?? cartData.total_price);
      if (checkoutAmt) checkoutAmt.textContent = '· ' + formatMoney(cartData.total_price);
    };

    const renderItem = (item) => {
      // /cart.js returns both .image (string) and .featured_image (object) — prefer the object
      const rawImg = (item.featured_image && item.featured_image.url) || item.image || '';
      // Ask Shopify CDN for a small-ish render; safe-fall to original if pattern doesn't match
      const img = rawImg.replace(/(\.(?:jpe?g|png|webp|gif|avif))(\?.*)?$/i, '_180x$1$2');
      const variantParts = [];
      (item.options_with_values || item.variant_options || []).forEach(opt => {
        if (opt && opt.value && opt.value !== 'Default Title') {
          variantParts.push(escapeHtml(opt.name ? opt.name + ': ' + opt.value : opt.value));
        }
      });
      // Fallback: split variant_title
      if (variantParts.length === 0 && item.variant_title && item.variant_title !== 'Default Title') {
        variantParts.push(escapeHtml(item.variant_title));
      }
      const variantLine = variantParts.length ? '<p class="cart-drawer__item-variant">' + variantParts.join(' · ') + '</p>' : '';

      const hasCompare = item.original_price && item.original_price > item.final_price;
      const priceHtml = hasCompare
        ? '<del>' + formatMoney(item.original_price) + '</del>' + formatMoney(item.final_price)
        : formatMoney(item.final_price);

      return ''
        + '<div class="cart-drawer__item" data-key="' + item.key + '">'
          + '<a href="' + item.url + '" class="cart-drawer__item-image">'
            + (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '')
          + '</a>'
          + '<div class="cart-drawer__item-body">'
            + '<p class="cart-drawer__item-title"><a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a></p>'
            + variantLine
            + '<p class="cart-drawer__item-price">' + priceHtml + '</p>'
            + '<div class="cart-drawer__item-controls">'
              + '<div class="cart-drawer__qty" data-qty>'
                + '<button type="button" data-qty-dec aria-label="Decrease quantity">−</button>'
                + '<span class="cart-drawer__qty-value">' + item.quantity + '</span>'
                + '<button type="button" data-qty-inc aria-label="Increase quantity">+</button>'
              + '</div>'
              + '<button type="button" class="cart-drawer__remove" data-remove>Remove</button>'
            + '</div>'
          + '</div>'
        + '</div>';
    };

    const changeQuantity = async (key, qty) => {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        if (!res.ok) throw new Error('Cart change failed');
        cartData = await res.json();
        render();
        updateHeaderCount();
      } catch (err) {
        console.error('[cart]', err);
        alert('Could not update cart. Please try again.');
      }
    };

    // Event delegation on the items container
    itemsEl?.addEventListener('click', e => {
      const itemEl = e.target.closest('[data-key]');
      if (!itemEl) return;
      const key = itemEl.dataset.key;

      if (e.target.closest('[data-qty-inc]')) {
        const cur = Number(itemEl.querySelector('.cart-drawer__qty-value').textContent) || 0;
        changeQuantity(key, cur + 1);
      } else if (e.target.closest('[data-qty-dec]')) {
        const cur = Number(itemEl.querySelector('.cart-drawer__qty-value').textContent) || 0;
        if (cur <= 1) changeQuantity(key, 0);
        else changeQuantity(key, cur - 1);
      } else if (e.target.closest('[data-remove]')) {
        changeQuantity(key, 0);
      }
    });

    closers.forEach(el => el.addEventListener('click', close));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    return { open, close, refresh, addItem };

    async function addItem(formData) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ description: 'Add to cart failed' }));
        throw new Error(err.description || 'Add to cart failed');
      }
      await refresh();
      open();
    }
  })();

  // Intercept header cart icon clicks → open drawer
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-cart-drawer-open]');
    if (!trigger || !CartDrawer) return;
    e.preventDefault();
    CartDrawer.open();
  });

  // Initial fetch so header count + drawer are warm on page load
  CartDrawer?.refresh();

  // ---------- Cart page (server-rendered lines, AJAX quantity/remove) ----------
  (function initCartPage() {
    const list = document.querySelector('[data-cart-page-items]');
    if (!list) return;

    async function change(key, qty) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        if (!res.ok) throw new Error('Cart change failed');
        location.reload();
      } catch (err) {
        console.error('[cart page]', err);
        alert('Could not update cart. Please try again.');
      }
    }

    list.addEventListener('click', e => {
      const line = e.target.closest('[data-key]');
      if (!line) return;
      const key = line.dataset.key;
      const valEl = line.querySelector('[data-qty-value]');
      const cur = Number(valEl?.textContent) || 0;

      if (e.target.closest('[data-cart-line-inc]')) {
        change(key, cur + 1);
      } else if (e.target.closest('[data-cart-line-dec]')) {
        change(key, Math.max(0, cur - 1));
      } else if (e.target.closest('[data-cart-line-remove]')) {
        change(key, 0);
      }
    });

    // Order note auto-save on blur
    const note = document.querySelector('[data-cart-note]');
    if (note) {
      let lastVal = note.value;
      note.addEventListener('blur', async () => {
        if (note.value === lastVal) return;
        lastVal = note.value;
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: note.value })
          });
        } catch (err) { console.error('[cart note]', err); }
      });
    }
  })();

  // ---------- Add-to-cart form intercept ----------
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const button   = form.querySelector('[type="submit"]');
    const textNode = button?.querySelector('[data-product-submit-text]') || button;
    const originalText = textNode?.textContent;
    if (button) { button.disabled = true; }
    if (textNode) { textNode.textContent = 'Adding...'; }
    try {
      const formData = new FormData(form);
      if (CartDrawer) {
        await CartDrawer.addItem(formData);
      } else {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('Add to cart failed');
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count > 0 ? cart.item_count : '');
      }
      if (textNode) textNode.textContent = '✓ Added';
      setTimeout(() => {
        if (textNode) textNode.textContent = originalText;
        if (button) button.disabled = false;
      }, 1500);
    } catch (err) {
      console.error(err);
      if (textNode) textNode.textContent = originalText;
      if (button) button.disabled = false;
      alert(err.message || 'Could not add to cart. Please try again.');
    }
  });

  // ---------- Localization auto-submit ----------
  document.querySelectorAll('.site-footer__locale select').forEach(sel => {
    sel.addEventListener('change', e => e.target.form.submit());
  });

})();
